import { AutoCalculate } from "global/Reducer/dataSlice";
import * as FAM from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

/**
 * Transformers:

 */
export class AutoCalculateTransformer extends BaseJsonTransformer {
    config: FAM.IGroupConfigurationConfig;

    constructor(config: FAM.IGroupConfigurationConfig) {
        super();
        this.config = config;
    }

    async before(json: FAM.IGroupConfigurationData): Promise<void> {

        const stateFeesAndPremiums = json.feesAndPremiums;
        const stateGroupNumbers = json.groupStructure.groupNumbers;
        const statePlans = json.plans;
        const stateClaimsARs = json.claimsARs;

        const autoCalculateResult = AutoCalculate(stateFeesAndPremiums, stateGroupNumbers, statePlans, stateClaimsARs, this.config);
    }

    async transformAttributeSet(attributeSet: FAM.IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> {

    }

    async after(json: FAM.IGroupConfigurationData): Promise<void> {
    }
}
